export const PASSWORD_MIN_LENGTH = 8;

export const CACHE_TTL = 600;
